import { Facebook, Twitter, Instagram, Share2 } from "lucide-react";

const SocialIcons = () => {
  const socials = [
    { icon: Facebook, color: "#1877F2", label: "Facebook" },
    { icon: Twitter, color: "#1DA1F2", label: "Twitter" },
    { icon: Instagram, color: "#E4405F", label: "Instagram" },
    { icon: Share2, color: "hsl(var(--gsg-teal))", label: "Share" },
  ];

  return (
    <div className="flex items-center gap-3">
      {socials.map(({ icon: Icon, color, label }) => (
        <button
          key={label}
          aria-label={label}
          className="w-10 h-10 rounded-full flex items-center justify-center  border border-border/50 hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-lg group"
        >
          <Icon
            size={18}
            className="text-muted-foreground transition-colors duration-300 group-hover:text-[var(--hover-color)]"
            style={{ ["--hover-color"]: color }}
          />
        </button>
      ))}
    </div>
  );
};

export default SocialIcons;
